<template>
    <div class="">
        <div class="header-panel hero has-banner-image desert">
            <div class="header-panel-content">
                  <Breadcrumb 
                    :levelTwoText = "'Features'"
                    :levelThreeText = "'Deserts'"

                    
                    />
               <div class="spacer" style="height:10px"></div>
                <div class="header-panel-inset" style="">
                  
                <Heading 
                    :heading = "'Desert Bike Travel'"
                    :subheading = "''"
                    :level="1"
                    :noSpaceBelow = "true"
                    :noSpaceAbove="true"
                />
                <p class="container is-size-6 is-size-7-mobile" style="color:black">
                    There's something magical about bikepacking in the desert.<br>
                    Sometimes it's all about endless vistas, clear starry nights, fascinating geology, and otherworldly flora.
                    Other times it's deep sand, strong headwinds, extreme temperatures, and cactus spikes in your tires.
                    Whatever the desert throws your way, these stories and route ideas will inspire and prepare you to take it on.<br><br> 
                </p>
                <TOC v-if="true"
                        :slot1text="'Blogs'"
                        :slot1link="'blogs'"
                        :slot2text="'Routes'"
                        :slot2link="'routes'"
                        :slot3text="'Books'"
                        :slot3link="'books'"
                        />
                </div>
                <div class="spacer" style="height:50px"></div>
            </div>
        </div>

        

    <!-- <div class="spacer" style="height:60px"></div> -->
        <div class="container">
            <div class="spacer" style="height:30px"></div>
            <Heading 
                :heading = "'Blog Posts'"
                :subheading = "''"
                :anchor = "'blogs'"
                :smaller="true"
            />

        <RadioFilter 
            v-on:selection-change="updateSelectedContinent"
            :options = "$continentsArray"
            :type = "'Continent'"
        />
        <div class="spacer" style="height:60px"></div>

        <div class="columns is-multiline is-variable is-4-desktop" v-if="!isLoading">
            <PageResultColumns  
                v-for="(page, idx) in this.resultPages"
                v-bind:key = idx 
                :page = "page"
                :approveMode = "false"
                :showYear="true"
            />
        </div>
        
    <div class="section card" ref="results" v-if="isLoading">
        <b-icon class="fas fa-spinner fa-spin"></b-icon>
        Loading...
    </div>
    <div class="section card" ref="results" v-if="!isLoading && resultPages.length == 0">
        <!-- <b-icon class="fas fa-spinner fa-spin"></b-icon> -->
        None yet :(  You can <router-link to="/add">submit a blog post</router-link> to start filling this section.
    </div>
    
    <div class="spacer" style="height:60px"></div>

    <b-button type="is-primary is-large" style="margin-bottom:10px" v-if="!noMorePages && resultPages.length > 0" @click="nextPage" v-scroll-to="{
            el:'#result-last',
            easing:'ease',
            offset: -100
        
    }">Load more</b-button>
    <!-- <div v-if="activeFilterCount > 0" style="padding: 30px 0px; font-size: 18px; text-align:left">To see more results, <a v-on:click="clearFilters">click here to clear filters</a></div> -->
    <b-button v-if="resultPages.length > 0" v-scroll-to="'#app'" class="is-large">Scroll to top</b-button>

    <div class="popular-routes" v-if="routesByStyle.length > 0">
        <div class="spacer" style="height:80px"></div>
        <div class="divider"></div>
        <div class="spacer" style="height:30px"></div>
        
        <Heading 
            :anchor="'routes'"
            :preheading = "'Popular'"
            :heading = "'Desert Routes'"
           
        />

        <!-- <h3 class='title is-size-2 is-size-3-mobile'  >{{$titleCase('Popular ' + (styleMap[style_name] ? styleMap[style_name] : style_name) + ' Routes')}}</h3> -->
        <div class="spacer" style="height:30px"></div>

        <div v-if="routesByStyle.length > 0">
            <ul >
                <li  class="list-link" v-for="(routeObj) in routesByStyle" v-bind:key="routeObj.display_name" >
                    
                    <RouteRow  
                        v-bind:routeObj = "routeObj"
                    />
                    
                </li>
            </ul>
        </div>
        <router-link to="/routes/" class="button is-size-4 is-size-5-mobile is-info" style="margin-top:10px;">See all routes</router-link>
        
    </div>
    <div class="spacer" style="height:30px"></div>


    <div class="places" v-if="countryData.length > 0">
        <div class="spacer" style="height:60px"></div>
        <div class="divider"></div>
        <div class="spacer" style="height:30px"></div>
        
        <Heading 
            :anchor="'places'"
            :preheading = "''"
            :heading = "'Popular Places'"
            :subheading = "'For Desert Riding'"
           
        />

        <!-- <h3 class='title is-size-2 is-size-3-mobile'  >{{$titleCase('Popular ' + (styleMap[style_name] ? styleMap[style_name] : style_name) + ' Routes')}}</h3> -->
        <div class="spacer" style="height:50px"></div>
        <div v-if="countryData.length > 0" class="columns is-multiline  is-vcentered">
           
                <div  class="list-link column is-4 " v-for="(place, idx) in countryData" v-bind:key="idx" >
                    <!-- <div class="column is-4"> -->
                    <PlaceCardSimple  
                        v-bind:placeObj = "place"
                        :country = "true"
                    />
                    <!-- </div> -->
                </div>
                <div  class="list-link column is-4 " v-for="state in stateData" v-bind:key="state" >
                    <!-- <div class="column is-4"> -->
                    <PlaceCardSimple  
                        v-bind:placeObj = "{ name: state }"
                        :state = "true"
                    />
                    <!-- </div> -->
                </div>
           
        </div>
        <!-- <router-link to="/routes/" class="button is-size-4 is-size-5-mobile is-info" style="margin-top:10px;">See all routes</router-link> -->
        
    </div>
    <div class="spacer" style="height:30px"></div>

    <div class="books" >
        <div class="spacer" style="height:60px"></div>
        <div class="divider"></div>
        <div class="spacer" style="height:30px"></div>

        <BooksList v-if="!isLoading" 
            :anchor="'books'"
            
            :heading = "'Books'"
            :subheading = "'About Desert Bike Travel'"
            :property = "styleMap.hasOwnProperty(style_name) ? styleMap[style_name] : style_name"
            :operator = "'=='"
            :value = "true"

            :headingFallback = "'Books'"
            :subheadingFallback = "'About Bike Touring'"
            :propertyFallback = "'touring'"
            :operatorFallback = "'=='"
            :valueFallback = "true"

            :num = "8"
            :isMinimal = "true"
        />

    </div>

    <div class="spacer" style="height:30px"></div>

    </div>

    <div class="spacer" style="height:30px"></div>
    <!-- <div class="divider"></div>
    <div class="spacer" style="height:10px"></div> -->

    <div style="background-color:rgba(185, 238, 255, 0.37);"> 
        <div class="spacer" style="height:5px"></div>
        <SocialSharePrompt :headerText="'Desert Bike Travel - BikeSleepBike'" :location="'bottom'" :label="'Share This Collection'" :labelColor="'black'"/>
        <div class="spacer" style="height:50px"></div>
    </div>

    <div class="spacer" style="height:80px"></div>
    <div class='container'>
        <p class="is-size-5">Do you write about your own desert bike adventures, or any other kind of bike adventure?</p><br>
        <router-link to="/share" class="button is-size-5 is-size-5-mobile is-info" style="margin-top:10px;">Submit Your Blog</router-link>
    </div>
    <div class="spacer" style="height:100px"></div>
    </div>
</template>

<script>
import PageResultColumns from '@/components/PageResultColumns';
// import PageResult from '@/components/PageResult';
import RadioFilter from '@/components/RadioFilter';
import Heading from '@/components/Heading';
import RouteRow from '@/components/RouteRow';
import CountryRow from '@/components/CountryRow';
import PlaceCardSimple from '@/components/PlaceCardSimple';
import Breadcrumb from '@/components/Breadcrumb';
// import Book from '@/components/Book';
import BooksList from '@/components/BooksList';
import SocialSharePrompt from '@/components/SocialSharePrompt';
// import BooksList from '@/components/BooksList';
import TOC from '@/components/TOC';

export default {
  name: 'FeatureDesert',
  components: {PageResultColumns, RadioFilter, Heading, RouteRow, CountryRow, PlaceCardSimple, Breadcrumb, BooksList, TOC, SocialSharePrompt},
  
//   props: ['style_name'],
  data () {
    return {
        style_name: "desert",
        countries: 
           [
               'OM',
               'AU',
               'EG',
               'SD',
               'MX',
               'NA'
               
           
           ],
        countryData: [],
        stateData:
            [
                'Arizona',
                'Nevada',
                
                'Utah'
            ],
        isLoading: false,
        noMorePages: false,
        lastVisibleResult: undefined,
        currentQuery: undefined,
        queryLimit: 21,
        resultPages: [],
        selectedContinent: "",
        routesByStyle: [],
        booksByStyle: [],
        styleMap: {'bike paths': 'bikepath', 'pavement': 'road'} // mapping from tag at page/post level to the bool associated with the route
    //    ridertags: ['solo female', 'solo', 'solo male', 'couple', 'fat bikes', 'over 65', 'diversify outdoors', 'LGBTQ+']

    }
  },
  computed: {
  
  },
  methods: {
      updateSelectedContinent(continent) {
          this.selectedContinent = continent;
        //   console.log("NEW CONT " + continent);
          var queryparts = this.translateStyleToQuery();
          this.fetchPages(queryparts[0], queryparts[1], queryparts[2], this.selectedContinent);
        //   if (this.selectedContinent == "All") {
        //     this.fetchPages(queryparts[0], queryparts[1], queryparts[2]);
        //   } else {
        //     this.fetchPagesByContinent(queryparts[0], queryparts[1], queryparts[2], this.selectedContinent);
        //   }
      },
      fetchPages(fieldname, querytype, value, continent) {
            if (this.$debug) {console.log("DEBUG: In function fetchPages");}
            // console.log(value);
            if (value != "") { // GET FILTERED
                this.$analytics.logEvent('fetch_results', { type: 'style', value: value});
                this.isLoading = true;
                var that = this;
                var result = [];
                this.noMorePages = false;
                this.lastVisibleResult = undefined;
                if (!continent || continent == '' || continent == "All") {
                    this.currentQuery = this.$db.collection("pages").where(fieldname, querytype, value).orderBy("year", "desc").orderBy("added", "desc");
                } else {
                    this.currentQuery = this.$db.collection("pages").where(fieldname, querytype, value).where("continent", "==", continent).orderBy("year", "desc").orderBy("added", "desc");
                }
                // this.currentQuery = this.$db.collection("pages").where(fieldname, querytype, value).orderBy("year", "desc").orderBy("added", "desc");
                this.currentQuery.limit(that.queryLimit).get()
                    .then(function(querySnapshot) {
                        querySnapshot.forEach(function(doc) {
                            // doc.data() is never undefined for query doc snapshots
                            var dataAndId = doc.data();
                            dataAndId['id'] = doc.id;
                            result.push(dataAndId);
                        
                        });
                        that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                        if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                            that.noMorePages = true;
                        }
                        that.resultPages = result;
                        that.isLoading = false;
                    })
                    .catch(function(error) {
                        console.log("Error getting pages by style: ", error);
                        that.isLoading = false;
                    });
            } 
        },
 
        nextPage() {
            if (this.$debug) {console.log("DEBUG: In function nextPage");}
            var that = this;
            var result = [];  
        
            if (this.lastVisibleResult) {
                this.noMorePages = false;
                this.currentQuery.startAfter(this.lastVisibleResult).limit(that.queryLimit).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    });
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    that.resultPages.push(...result);
                });         
            } else {
                this.noMorePages = true;
            }
        },
        getRoutesByStyle() {
            // console.log("Getting route data for style " + this.style_name);
            this.routesByStyle = [];
            // var result = [];
            var that = this;
            var pageCountData = {};
            var routesMetadata = [];
            // first get routes page counts
            this.$db.collection("page_counts").doc('routes').get()
            .then(function(doc) {
                if (doc.exists) {
                    var temp = {};
                    temp[doc.id] = doc.data();
                    pageCountData = temp.routes;
                    // console.log(style);
                    var style = "";
                    if (that.styleMap.hasOwnProperty(that.style_name)) {
                        style = that.styleMap[that.style_name];
                    } else {
                        style = that.style_name;
                    }
                    // console.log(style);
                    that.$db.collection("routes").where(style, "==", true).get().then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            // doc.data() is never undefined for query doc snapshots
                            var temp2 = {};
                            routesMetadata.push(doc.data());
                        });

                        // then merge the two
                        for (var i = 0; i < routesMetadata.length; i++) {
                            var displayName = routesMetadata[i].display_name;
                            if (displayName in pageCountData) {
                                var newobj = routesMetadata[i];
                                newobj.post_count = pageCountData[displayName].post_count;
                                that.routesByStyle.push(newobj);
                            }
                        }
                        // console.log(that.routesData);
                        that.routesByStyle.sort((a, b) => (a.post_count > b.post_count) ? -1 : 1);
                    });
                } else {
                    console.log("ERROR: Can't fetch links by type", that.type);
                }

            })
            .catch(function(error) {
                console.log("Error getting links by type: ", error);
            });
            

        },
        translateStyleToQuery() {
            var result = [];
            // this.style_name = this.$route.params.style_name;
            var surfaces = ['gravel', 'singletrack', 'pavement', 'bike paths'];
            if (surfaces.includes(this.style_name)) {
                result = ["surfaces", "array-contains", this.style_name]
            }
            var styles = ['touring', 'bikepacking'];
            if (styles.includes(this.style_name)) {
                result = [this.style_name, "==", true];
            }
            var features = ['mountains', 'desert', 'camping', 'ocean', 'cities', 'people', 'heat', 'cold', 'remoteness', 'snow', 'relaxation', 'challenge'];
            if (features.includes(this.style_name)) {
                result = ["features", "array-contains", this.style_name];
            }
            if (this.style_name == "racing") {
               result = ["features", "array-contains", this.style_name];
            }
            if (this.style_name == "short") {
               result = ["short", "==", true];
            }
            // console.log(result);
            return result;
        },
        fetchBooksByStyle(style) {
            if (this.$debug) {console.log("DEBUG: In function fetchBooksByStyle");}
        
        // if (value != "") { // GET FILTERED
            this.$analytics.logEvent('fetch_results', { type: 'books by style', value: style});
            var that = this;
            var result = [];
           
            this.$db.collection("books").where(style, '==', true).orderBy("title", "asc").limit(8).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    
                    });
                   
                    that.booksByStyle = result;
                    console.log(that.booksByCountry);
                    // that.isLoading = false;
                })
                .catch(function(error) {
                    console.log("Error getting books by style: ", error);
                    // that.isLoading = false;
                });
        // } 
        },   
        getTitle(stylename) {
            
            if (stylename == 'bikepacking') {
                return "Bikepacking";
            } else if (stylename == 'touring') {
                return "Bicycle Touring";
            } else if (stylename == 'racing') {
                return "Bikepack Racing"
            } else if (stylename == 'short') {
                return "Short Bike Trips"
            } else if (stylename == 'singletrack') {
                return "Singletrack"
            }

            else return this.$titleCase(stylename);
        },
        getSubtitle(stylename) {
            
            if (stylename == 'bikepacking') {
                return "Blog Posts";
            } else if (stylename == 'touring') {
                return "Blog Posts";
            } else if (stylename == 'racing') {
                return "Blog Posts"
            } else if (stylename == 'singletrack') {
                return "Bikepacking Blog Posts"
            } 
            else return "Bike Travel Blog Posts";
        },
        aboutOrFeaturing(stylename) {
            
            if (stylename == 'bikepacking') {
                return "About";
            } else if (stylename == 'touring') {
                return "About";
            } else if (stylename == 'racing') {
                return "About"
            } else return "Featuring";
        },
        getCountryData() {
            // console.log("Getting route data for country " + this.country_name);
            // var result = [];
            var that = this;
            var pageCountData = {};
            var countriesMetadata = [];
            // first get routes page counts
            this.$db.collection("page_counts").doc('countries').get()
            .then(function(doc) {
                if (doc.exists) {
                    var temp = {};
                    temp[doc.id] = doc.data();
                    pageCountData = temp.countries;
                    // var countryCodesArray = [];
                    // var countriesArray = this.getCountries(continent);
                    for (const idx in that.countries) {
                        var countrycode = that.countries[idx];
                        // var contMapObj = continent_map.find(obj => {
                        //     return obj['Two_Letter_Country_Code'] === countrycode;
                        // })
                        // var continentName = contMapObj['Continent_Name'];
                        // if (continentName == that.$titleCase(that.continent)) {
                        var countryMetadata = {};
                        countryMetadata.id = countrycode;
                        // countryMetadata.type = "country"
                        // countryMetadata.display_name = that.$countrymap[countrycode];
                        countryMetadata.post_count = pageCountData[countrycode]['post_count'];
                        // countryMetadata.continent = continentName;
                       
                        that.countryData.push(countryMetadata);
                        // countryCodesArray.push(countrycode);
                        // }
                    }
                 
                    that.countryData.sort((a, b) => (a.post_count > b.post_count) ? -1 : 1);
                    // });
                } else {
                    console.log("ERROR: Can't fetch country data for desert");
                }
            })
            .catch(function(error) {
                console.log("Error getting country data: ", error);
            });
        },
    

  },
  metaInfo() {
        var title =  'Desert Bike Travel - Featured Story and Route Collection'
        var description = "Explore desert bikepacking and touring routes, trip journals, blog posts, and more in this featured collection of bike travel resources all about deserts.";
        return {
            title: title + ' | BikeSleepBike',
            titleTemplate: this.$titleTemplate,
            description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                // { name: "og:image", property: "og:image", content: 'https://bikesleepbike.com/share_desert.jpg'  },
                // { name: "twitter:card", property: "twitter:card", content: 'https://bikesleepbike.com/share_desert.jpg'  },
                 { name: "og:image", property: "og:image", content: this.$imageBase + 'share_desert.jpg'  },
                { name: "twitter:card", property: "twitter:card", content: this.$imageBase + 'share_desert.jpg'  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com/feature/desert"}
            ]
            // title: 'Browse | Bike Sleep Bike',
            // description: "Find bike travel blogs"
            
        }
    },
   
    mounted() {
        this.style_name = 'desert';
        var queryparts = this.translateStyleToQuery();
        this.getCountryData();
        this.fetchPages(queryparts[0], queryparts[1], queryparts[2]);
        if ( ['gravel', 'racing', 'bikepacking', 'singletrack', 'touring', 'desert', 'mountains', 'ocean', 'pavement', 'road', 'bike paths', 'gravel'].includes(this.style_name) ) {
            this.getRoutesByStyle();
            // this.fetchBooksByStyle(this.style_name);
        }
        
     
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  

</style>

<style>
    .page-results {
        max-width: 1500px;
        margin-left: auto;
        margin-right: auto;
    }
    .hero.has-banner-image.desert {
        /* background-color:black; */
        background-image: url(https://bikesleepbike.com/banner_desert3.jpg);
        background-size: cover;
        background-position: center top;
        display:flex;
        position:relative;
        overflow:hidden;
      /*  object-fit: fill; */
        object-position: bottom center;
        width: 100%;
        /* height: 600px; */
        /* opacity: 1; */
        background-color: transparent;
    }

        .hero.has-banner-image.desert::before {    
        content: "";
        /* background-image: url(https://bikesleepbike.com/thumb_desert3_large.jpg); */
        /* background-size: cover; */
        position: absolute;
        /* background-position: center bottom; */
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        background-color:rgba(255, 255, 255, 0.473);
        /* opacity: 0.25; */
        /* z-index:0; */
    }

    .header-panel-content {
        z-index:19;
    }
    .hero.has-banner-image.desert .header-panel-inset {
        max-width:1000px; 
        font-weight:bold; 
        background-color:#ffffffb4; 
        padding:20px; 
        margin-left:auto; 
        margin-right:auto; 
        border-radius:8px;
    }
    /* .hero.has-background-image::before {
        content: "";
        position: absolute;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        background-color: rgba(255, 255, 255, 0.726);
    } */
</style>


// WEBPACK FOOTER //
// src/components/FeatureDesert.vue